exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.search-button {\n  min-width: 7vw;\n}\n", "", {"version":3,"sources":["/./client/components/buttons/buttonSearch/ButtonSearch.vue?626445fe"],"names":[],"mappings":";AAsBA;EACA,eAAA;CACA","file":"ButtonSearch.vue","sourcesContent":["<template src='./buttonSearch.pug' lang='pug'></template>\n\n<script>\nimport ButtonPrimary from '../buttonPrimary/ButtonPrimary'\n\nexport default {\n  name: 'ButtonSearch',\n\n  components: {\n    ButtonPrimary\n  },\n\n  props: {\n    isDisabled: {\n      type: Boolean,\n      required: true\n    }\n  }\n}\n</script>\n\n<style>\n.search-button {\n  min-width: 7vw;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2e8324c6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/buttons/buttonSearch/ButtonSearch.vue
// module id = 1054
// module chunks = 0